import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Bold = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        d="M4 2H9.27115C9.77776 2 10.2313 2.0745 10.6319 2.22349C11.0443 2.37249 11.3918 2.5788 11.6746 2.84241C11.9573 3.10602 12.1694 3.43266 12.3108 3.82235C12.4639 4.20057 12.5405 4.61891 12.5405 5.07736C12.5405 5.53582 12.4757 5.9255 12.3461 6.24642C12.2283 6.55587 12.0634 6.81375 11.8513 7.02006C11.651 7.22636 11.4154 7.38109 11.1444 7.48424C10.8852 7.58739 10.6142 7.6447 10.3315 7.65616V7.75931C10.6025 7.75931 10.8911 7.81089 11.1974 7.91404C11.5155 8.01719 11.8042 8.18338 12.0634 8.41261C12.3343 8.63037 12.5582 8.91691 12.7349 9.27221C12.9116 9.61605 13 10.0458 13 10.5616C13 11.043 12.9175 11.4957 12.7526 11.9198C12.5994 12.3324 12.3815 12.6934 12.0987 13.0029C11.816 13.3123 11.4802 13.5587 11.0914 13.7421C10.7026 13.914 10.2785 14 9.81899 14H4V2ZM6.33274 12.0745H9.14745C9.59514 12.0745 9.9427 11.9656 10.1901 11.7479C10.4375 11.5186 10.5612 11.192 10.5612 10.7679V10.1834C10.5612 9.75931 10.4375 9.43267 10.1901 9.20344C9.9427 8.97421 9.59514 8.8596 9.14745 8.8596H6.33274V12.0745ZM6.33274 7.00287H8.77633C9.20046 7.00287 9.53035 6.89398 9.76598 6.67622C10.0016 6.44699 10.1194 6.1318 10.1194 5.73066V5.19771C10.1194 4.79656 10.0016 4.48711 9.76598 4.26934C9.53035 4.04011 9.20046 3.9255 8.77633 3.9255H6.33274V7.00287Z"
      />
    </svg>
  )
})

export default Bold
